import * as Msdyn365 from '@msdyn365-commerce/core';
import Cookies from 'universal-cookie';
const getZipCode = (ctx: Msdyn365.IActionContext): string | undefined => {
    const cookie = new Cookies();
    const zipcode = cookie.get('zip_code') ? cookie.get('zip_code') : ctx?.requestContext?.geoLocation?.zipCode;
    return zipcode ?? undefined;
};
export default getZipCode;